module.exports = {
          srcSet: __webpack_public_path__ + "public/images/e529865d6e857bc342def81055eef387-1774.jpg"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/e529865d6e857bc342def81055eef387-1774.jpg",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/e529865d6e857bc342def81055eef387-1774.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/e529865d6e857bc342def81055eef387-1774.jpg"},
          
          width: 1774,
          height: 887
        }